<template>
    <Fragment>
        <div class="radio-group" @click="onChangePaymentRadio">
            <div class="radio-heading">
                <span class="radio-conteiner">
                    <input
                        type="radio"
                        name="payment_radio"
                        :value="payment_data"
                        v-model="payment_selected"
                        @change="onChangePaymentRadio($event)"
                    >
                </span>
                <span class="forma-conteiner">
                    <i class="fas fa-credit-card"></i>
                    Cartão de crédito
                </span>
            </div>
        </div>
        <div class="content-payment">
                <div v-if="payment_selected && payment_data.id == payment_selected.id">
                     <!--BRAND CARD-->
                    <div class="form-group required-field">
                        <label for="brandCardYapay">Bandeira do cartão</label>
                        <select
                            class="form-payment"
                            @change="setInstallments($event.target.value)"
                            @input="$emit('update:method', $event.target.value)"
                            :value="method"
                        >
                            <option value="" selected>Selecione a bandeira</option>
                            <option v-for="item in payment_data.payment_method" :key="item.id" :value="item.method">{{item.method}}</option>
                        </select>
                        <div v-if="validate.formYapayCard.method.$error && !validate.formYapayCard.method.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END BRAND CARD-->
                    <!--NUMBER CARD-->
                    <div class="form-group required-field">
                        <label for="numberCardYapay">Número do Cartão de Crédito</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="numberCardYapay"
                            name="numberCardYapay"
                            :value="number"
                            @input="$emit('update:number', $event.target.value)"
                        />
                        <div v-if="validate.formYapayCard.number.$error && !validate.formYapayCard.number.required" class="required">* Obrigatório</div>
                        <div v-if="!cardValid" class="required">Não aceitamos esta bandeira de cartão</div>
                    </div>
                    <!--END NUMBER CARD-->
                    <!--HOLDER CARD-->
                    <div class="form-group required-field">
                        <label for="holderCardYapay">Titular do cartão</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="holderCardYapay"
                            name="holderCardYapay"
                            v-uppercase
                            :value="holder"
                            @input="$emit('update:holder', $event.target.value)"
                        />
                        <div v-if="validate.formYapayCard.holder.$error && !validate.formYapayCard.holder.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END HOLDER CARD-->



                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group required-field mb-0">
                                <label>Vencimento do cartão</label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group required-field mb-0">
                                <label>Cvv</label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <!--EXPIRY MONTH-->
                        <div class="col-md-4">
                            <select
                                class="form-payment"
                                @input="$emit('update:expiry_month', $event.target.value)"
                            >
                                <option value="" selected>Mês</option>
                                <option v-for="count in 12" :key="count" :value="count < 10 ? '0'+count : count">{{ count < 10 ? '0'+count : count }}</option>
                            </select>
                            <div v-if="validate.formYapayCard.expiry_month.$error && !validate.formYapayCard.expiry_month.required" class="required">* Obrigatório</div>
                        </div>
                        <!--END EXPIRY MONTH-->

                        <!--EXPIRY YEAR-->
                        <div class="col-md-4">
                            <select
                                class="form-payment"
                                @input="$emit('update:expiry_year', $event.target.value)"
                            >
                                <option value="" selected>Ano</option>
                                <option v-for="(n, $index) in 12" :key="n" :value="$index + countDate">{{$index + countDate}}</option>
                            </select>
                            <div v-if="validate.formYapayCard.expiry_year.$error && !validate.formYapayCard.expiry_year.required" class="required">* Obrigatório</div>
                        </div>
                        <!--END EXPIRY YEAR-->

                        <!--CVV CARD-->
                        <div class="col-md-4">
                            <input
                                type="text"
                                class="form-payment"
                                id="cvvYapay"
                                name="cvvYapay"
                                :max-length="maxlengthCvv"
                                placeholder="cvv"
                                @input="$emit('update:cvv', $event.target.value)"
                            />
                            <div
                                v-if="validate.formYapayCard.cvv.$error && !validate.formYapayCard.cvv.required"
                                class="required"
                            >
                                * Obrigatório
                            </div>
                        </div>
                        <!--END CVV CARD-->
                    </div>

                    <!--INSTALLMENTS-->
                    <div class="form-group required-field">
                        <label for="installments_yapay">Parcelas</label>
                         <select class="form-payment" @input="$emit('update:installment', $event.target.value);setPayment($event.target.value)">
                            <option  v-for="i in installments" :key="i.split" :value="i.split" :selected="i.split == 1">
                                <!-- {{  i.split == 1
                                    ? "à vista - "+currency.money(i.value_split)
                                    : i.split+"x de "+currency.money(i.value_split)+
                                    (Math.round(totalAmount / i.split) < Math.round(i.value_split) ? " com juros":" sem juros" )
                                }} -->
                                {{showInstallment(i)}}
                            </option>
                        </select>
                        <div v-if="validate.formYapayCard.installment.$error && !validate.formYapayCard.installment.required" class="required">* Selecione uma parcela</div>
                    </div>
                    <!--END INSTALLMENTS-->
                </div>
        </div>
    </Fragment>
</template>

<script>
import {Fragment}  from 'vue-fragment'
import {mapState, mapActions} from 'vuex'
import Currency from '../../helpers/parseCurrency'

export default {
    name: 'Yapay',
     directives: {
        "uppercase": {
            update: function (el) {
                el.value = el.value.toUpperCase()
            }
        }
    },
    props: {
        //numero de parcelas sem juros definido pela empresa no painel administrativo
        interest_free_installments: {
            default: 0
        },
        payment_data: {
            required: true,
            default: Object,
            type: Object
        },
        payment_selected: {
            default: Object,
            type: Object
        },
        holder: {
            default: ''
        },
        method: {
            default: '',
        },
        number: {
            default: ''
        },
        expiry_month: {
            default: ''
        },
        expiry_year: {
            default: ''
        },
        cvv: {
            default: ''
        },
        installment: {
            default: ''
        },
        validate: {
            required: true
        },
        shippingMethod:{
            default:null
        },
        min_price_installment:{
            default:null
        },
        max_installments:{
            default:null
        },
        total_with_fee: {
            default:null
        }
    },
    components: {
        Fragment
    },
    data() {
        return {
            maxlengthCvv: 3,
            installments: [],
            disabledInstallments: true,
            countDate: 0,
            currency: Currency,
            cardValid: true,
            isLoading:true,
            splittings_yapay:[]
        }
    },
    created() {
        this.countDate = new Date().getFullYear()
    },
    methods: {
        ...mapActions("cart", [
            "ActionSetItemsCart"
        ]),
        ...mapActions("payment", [
            "ActionGetSimulationYapay"
        ]),
        onChangeInstallment(event)
        {
            let selected = event.target.value.split(';')
            let itemsCart = this.itemsCart
            itemsCart.totalAmount = selected[2]
            this.ActionSetItemsCart(itemsCart)
        },
        onChangePaymentRadio() {
            this.$emit('onChangePayment', this.payment_data)
        },
        async getSimulation(data){
            let env = process.env.NODE_ENV == 'production' ? {env: "production"} : {env: "sandbox"}
            try {
                let fingerprint = document.getElementsByName("finger_print");
                if(fingerprint.length  ==  0) {
                    window.yapay.FingerPrint(env)
                }

            } catch (error) {

            }
            let result = await this.ActionGetSimulationYapay(data);
            let splittings = result.data.splittings
            this.splittings_yapay = splittings
            this.installments = []
            let max_slpit = this.maxNumberOfInstallments
            for (let i = 0; i < max_slpit ; i++) {
                const element = splittings[i];
                this.installments.push(element)
            }
        },
        async setInstallments(value){
            let data = {
                brand:value,
                totalAmount:this.totalAmount
            }
            await this.getSimulation(data)
        },
        setPayment(index) {
            let total_fee = this.installments.find(el => el.split == index)
            this.$emit('update:total_with_fee', total_fee.value_transaction)
        },

        showInstallment(index) {
           return `${index.split == 1 ? 'À vista - ': index.split + 'x de '}${this.currency.money(this.addInstallmentFeeToTotalAmount(index))} ${this.validateWithOrWithoutAditionals(index)}`;
        },

        validateWithOrWithoutAditionals(index) {
            if(Number(index.value_transaction) > Number(this.totalAmount)){
                return "com juros";
            }
            return index == 1 ? '' : "sem juros";
        },

        addInstallmentFeeToTotalAmount(index) {

            return Number(index.value_split)
        },
    },
    computed: {
        ...mapState("cart", [
            "itemsCart"
        ]),
        maxNumberOfInstallments() {
            let installments = [this.maxInstallments, this.splittings_yapay?.length ?? 12]
            if(Number(this.payment_selected.price_min_split ?? null) > 0) {
                let split = Math.floor(this.totalAmount / Number(this.payment_selected.price_min_split))
                if(split > 12) {
                    split = 12;
                }else if(split < 1) {
                    split = 1
                }
                installments.push(split)
            }
            return Math.min.apply(Math, installments)
        },

        maxInstallments() {
            if( !this.payment_selected.max_installments || this.payment_selected.max_installments < 1 ) {
                return 12;
            }
            return this.payment_selected.max_installments
        },
        totalAmount() {
            return this.itemsCart.totalAmount.toFixed(2)
        }
    },
    watch:{
        async shippingMethod(val){
            if(!val)return
            if(!this.method)return
            let data = {
                brand:this.method,
                totalAmount:this.totalAmount
            }
            await this.getSimulation(data)
        }
    }
}
</script>
